<div class="icon-square">
  <mat-icon>{{ icon }}</mat-icon>
</div>
<p>{{ text }}</p>
<mat-icon class="dismiss-icon" (click)="dismiss()">close</mat-icon>
